import { ConfigurationDto } from "../models"
import { PatchPayload } from "../services/types"

export const ACTION_TYPES = {
    FETCH : "FETCH_INVENTORY_CONFIGURATION" as const,
    FETCH_SUCCESS: "FETCH_INVENTORY_CONFIGURATION_SUCCESS" as const,
    UPDATE: "UPDATE_INVENTORY_CONFIGURATION" as const,
    PATCH: "PATCH_INVENTORY_CONFIGURATION" as const,
}

export type Actions =
    | { type: typeof ACTION_TYPES.FETCH, payload: string }
    | { type: typeof ACTION_TYPES.FETCH_SUCCESS, payload: ConfigurationDto }
    | { type: typeof ACTION_TYPES.UPDATE, payload: PatchPayload }
    | { type: typeof ACTION_TYPES.PATCH }



// WEBPACK FOOTER //
// ./src/state/inventory/configuration/actions/types.ts